<template>
  <div class="row">
    <div class="col-md-12 col-xl-12 col-xm-12">
      <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
        <Form ref="redeForm" @submit="payer" :validation-schema="usagerSchema">
          <div class="card-body p-15 p-sm-20 p-md-25 p-lg-30">
            <h5 class="card-title fw-bold mb-15 mb-lg-20 mb-xl-25"></h5>
            <div class="border p-2 p-lg-4 border-dark border-opacity-10">
              <div class="row">
                <div class="col-md-12 col-xl-12 col-xm-12">
                  <label for="contrat" class="form-label fw-medium text-black">
                    <span> Usager</span>
                    <span>
                      <a
                        href="#"
                        data-bs-toggle="modal"
                        data-bs-target="#AddUsagerModal"
                        @click="ajouterUsager"
                        type="button"
                        ><span
                          class="badge text-bg-success"
                          style="margin-left: 0.3em"
                          >A</span
                        ></a
                      >
                      <a
                        href="#"
                        data-bs-toggle="modal"
                        data-bs-target="#AddUsagerModal"
                        @click="modifUsager"
                        type="button"
                        ><span
                          class="badge text-bg-secondary ml-5"
                          style="margin-left: 0.3em"
                          >M</span
                        ></a
                      >
                    </span>
                  </label>
                  <Field
                    name="usager"
                    v-model="usager"
                    class="form-control shadow-none fs-md-15 text-black"
                    v-slot="{ field }"
                  >
                    <Multiselect
                      v-model="field.value"
                      v-bind="field"
                      :filter-results="false"
                      :min-chars="2"
                      :resolve-on-load="false"
                      :delay="0"
                      :searchable="true"
                      :options-limit="300"
                      :options="
                        async (query) => {
                          if (query.length >= 3) {
                            const results = await reupererUsagers(query);
                            if (results && results.length > 0) {
                              return results;
                            } else if (results.length >= 3) {
                              return [
                                {
                                  value: '',
                                  label: 'Aucun enregistrement trouvé',
                                },
                              ];
                            } else {
                              return [];
                            }
                          }
                        }
                      "
                      noOptionsText="Tapez au moins deux caractères"
                      placeholder="Rechercher un contrat"
                    />
                  </Field>
                  <ErrorMessage name="usager" class="text-danger" />
                </div>
                
                
                <div class="col-md-6 col-xl-6 col-xm-12">
                  <div class="form-group">
                    <label class="form-label fw-medium text-black">
                      Payable
                    </label>
                    <Field name="mois" v-slot="{ field }" v-model="mois">
                      <Multiselect
                        mode="tags"
                        :multiple="true"
                        :options="moiss"
                        :searchable="true"
                        v-model="field.value"
                        v-bind="field"
                        placeholder="Sélectionner les mois à payer"
                      />
                    </Field>
                    <ErrorMessage name="mois" class="text-danger" />
                  </div>
                </div>
                <div class="col-md-3 col-xl-3 col-xm-12">
                  <div class="form-group">
                    <label
                      for="montant"
                      class="form-label fw-medium text-black"
                    >
                      Montant
                    </label>
                    <Field
                      name="montant"
                      v-model="montant"
                      :disabled="true"
                      class="form-control shadow-none fs-md-15 text-black"
                    />
                    <ErrorMessage name="montant" class="text-danger" />
                  </div>
                </div>
                <div class="col-md-3 col-xl-3 col-xm-12">
                  <div class="form-group mb-15 mb-sm-20 mb-md-25">
                    <label class="form-label fw-medium text-black">
                      Mode de paiement
                    </label>
                    <Field name="mode" v-slot="{ field }">
                      <Multiselect
                        :options="modes"
                        :multiple="false"
                        :searchable="true"
                        v-model="field.value"
                        v-bind="field"
                        placeholder="Sélectionner un mode"
                      />
                    </Field>
                    <ErrorMessage name="mode" class="text-danger" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            class="card-footer text-md-end text-xl-end text-sm-center p-15 p-sm-20 p-md-25 p-lg-30 bg-white"
          >
            <button
              class="default-btn me-20 transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 rounded-1 fs-md-15 fs-lg-16 bg-success"
              type="submit"
            >
              Payer
            </button>
            <router-link
              to="/liste-paiement"
              class="btn btn-danger transition border-0 lh-1 fw-medium"
              ><i class="flaticon-delete lh-1 me-1 position-relative top-2"></i>
              <span class="position-relative"></span>Annuler
            </router-link>
          </div>
        </Form>
      </div>
    </div>
  </div>
  <AddUsagerModal
    :item="selectedItem"
    @close="recharger"
    @recuperation="recuperation"
    @open="show_Modal"
  />
</template>

<script lang="ts">
import { defineComponent, ref, watch, reactive, toRef, onMounted } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import {
  error,
  success,
  format_date,
  telechargerFichier2,
  showModal,
  getUrlApiForFiles,
  getMonthsWithinRange,
  getMonthsWithinRange2,
} from "@/utils/utils";
import { useRouter } from "vue-router";
import ApiService from "@/services/ApiService";
import JwtService from "@/services/JwtService";
import * as Yup from "yup";
import Multiselect from "@vueform/multiselect";
import AddUsagerModal from "./Usager.vue";
import axios from "axios";
import {
  openKkiapayWidget,
  addKkiapayListener,
  removeKkiapayListener,
} from "kkiapay";
import Swal from "sweetalert2";
import CryptoJS from "crypto-js";
import { KKIAPAY } from "@/models/KKIAPAY";
import router from "@/router";

export default defineComponent({
  name: "AddPaiement",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect,
    AddUsagerModal,
  },
  setup: () => {
    const selectedImp = ref(null);

    // Fonction pour mettre à jour l'ID sélectionné
    const selectImp = (valeur: any) => {
      selectedImp.value = valeur;
    };

    const nombre1 = ref(1);
    const nombre2 = ref(12);

    const usagerSchema = Yup.object().shape({
      usager: Yup.string().required("L'usager est obligatoire"),
      mois: Yup.array()
        .typeError("Veuillez entrer un nombre")
        .required("Le nombre de mois est bligatoire"),
      mode: Yup.number().required("Le mode est obligatoire"),
      montant: Yup.number().required("Le montant est obligatoire"),
    });
    const selectedItem = ref();
    const impayes = ref<any[]>([]);
    const show_Modal = (el) => {
      showModal(el);
      selectedItem.value = 0;
    };

    const ajouterUsager = () => {
      selectedItem.value = null;
    };

    const modifUsager = () => {
      selectedItem.value = usager.value;
    };
    const recharger = () => {
      usagers.value = [];
    };
    const usager = ref();
    const impp = ref(null);
    const montant = ref(0);
    const somRedevance = ref(0);
    var check = reactive({
      typeError: "RAS",
      idTransaction: 0,
    });

    const recuperation = async(val) => {
      //usagers.value = val;
      //usager.value = val[0]["value"];
      if(val.length>0){
        await regularisation(val[0]["value"])
        usager.value = val[0]["value"];
      }
      
    };

    async function successHandler(response, values, { resetForm }) {
      // Mise à jour de l'objet check avec les informations de la réponse de succès
      check.typeError = "SUCCESS";
      check.idTransaction = response.transactionId;
      values["idTransaction"] = check.idTransaction;
      values["check"] = check;
      // Bloc de code à exécuter lorsque le paiement est un succès
      if (check.typeError === "SUCCESS") {
        // Appel de la fonction addAbonnement et attente de son exécution
        await addAPaiement(values, { resetForm });
      } else {
        check.typeError = "ECHOUE";
        check.idTransaction = 0;
      }

      // Retourne les données après l'exécution
      return { check, response };
    }

    async function failHandler(response, values, { resetForm }) {
      // Mise à jour de l'objet check avec les informations de l'échec
      check.typeError = "ECHOUE";
      check.idTransaction = response.transactionId;

      values["check"] = check;
      if (check.typeError === "ECHOUE") {
        // Appel de la fonction addAbonnement et attente de son exécution
        await addAPaiement(values, { resetForm });
      }

      // Retourne les données après l'exécution
      return { check, response };
    }

    const usagers = ref([]);
    const mode = ref();
    const mois = ref<any[]>([]);
    const moiss = ref<any[]>([]);
    const modes = ref([]);
    const lesUsagers = ref<any[]>([]);
    const reupererMode = async () => {
      try {
        const response = await ApiService.get("listeMode");
        if (response.data) {
          modes.value = response.data.data.map((el) => {
            return {
              value: el.id,
              label: el.libelle,
            };
          });
        }
      } catch (err) {
        error(err);
      }
    };

    const regularisation = async(matricule) => {
      try {
        const response = await ApiService.post("getUsagerByKey", { matricule });
        lesUsagers.value = response.data.data;
        if (response.data) {
          return (usagers.value = response.data.data.map((el) => {
            return {
              value: el.matricule,
              label: `${el.matricule} || ${el.nom}  ${el.prenom}  ${el.tel ? " - " + el.tel : ""}`,
            };
          }));
        }
      } catch (err) {
        console.log("Err ===> ", err);
        error(err);
      }
    }
    const reupererUsagers = async (recherche) => {
      try {
        const response = await ApiService.post("getUsagerByKey", { recherche });
        lesUsagers.value = response.data.data;
        if (response.data) {
          return (usagers.value = response.data.data.map((el) => {
            return {
              value: el.matricule,
              label: `${el.matricule} || ${el.nom}  ${el.prenom}  ${el.tel ? " - " + el.tel : ""}`,
            };
          }));
        }
      } catch (err) {
        error(err);
      }
    };

    const payer = async (values, { resetForm }) => {
      if (values.mois.length < 1) {
        Swal.fire({
          title: "Erreur",
          toast: true,
          text: "Il faut sélectionner au moins un mois",
          icon: "error",
          timer: 5000,
          position: "top-right",
          showConfirmButton: false,
        });
        return;
      }
      if (values.mode == 1) {
        try {
          const result = await Swal.fire({
            text:
              "Vous êtes sur le point de faire un paiement d'une somme de " +
              values.montant +
              " F CFA",
            icon: "warning",
            buttonsStyling: true,
            showCancelButton: true,
            confirmButtonText: "Payer",
            cancelButtonText: `Annuler`,
            allowOutsideClick: false,
            allowEscapeKey: false,
            heightAuto: false,
            customClass: {
              confirmButton: "btn btn-danger",
            },
          });

          if (result.isConfirmed) {
            values["check"] = KKIAPAY.check;
            await addAPaiement(values, { resetForm });
          }
        } catch (error) {
          //
        }
        resetForm();
      }
      if (values.mode == 2) {
        try {
          const result = await Swal.fire({
            text:
              "Vous êtes sur le point de faire un paiement d'une somme de " +
              values.montant +
              " F CFA",
            icon: "warning",
            buttonsStyling: true,
            showCancelButton: true,
            confirmButtonText: "Payer",
            cancelButtonText: `Annuler`,
            allowOutsideClick: false,
            allowEscapeKey: false,
            heightAuto: false,
            customClass: {
              confirmButton: "btn btn-danger",
            },
          });

          if (result.isConfirmed) {
            KKIAPAY.kkia(values.montant);
            await new Promise<void>((resolve) => {
              addKkiapayListener("failed", (event) => {
                failHandler(event, values, { resetForm });
                resolve();
              });

              addKkiapayListener("success", (event) => {
                successHandler(event, values, { resetForm });
                resolve();
              });

              const checkRef = toRef(check);

              let resolved = false;

              const intervalId = setInterval(() => {
                if (!resolved && checkRef.value.typeError !== "RAS") {
                  clearInterval(intervalId);
                  resolved = true;
                  resolve();
                }
              }, 500);
            });
          }
        } catch (error) {
          //
        }
      }
    };

    const openAndPrint = (url: string) => {
      const newWindow = window.open(url, "_blank");

      if (newWindow) {
        newWindow.onload = () => {
          newWindow.print();
        };
      } else {
        console.error("Impossible d'ouvrir la fenêtre");
      }
    };
    function openNewWindow(data: any) {
      openAndPrint(getUrlApiForFiles("Recu", data.refPaiement + ".pdf"));
    }

    const addAPaiement = async (values, { resetForm }) => {
      await ApiService.post("/paiement/ambulant", values)
        .then(async ({ data }) => {
          if (data.code == 201) {
            success(data.message);
            resetForm();
            router.push({ name: "ListePaiementAmbulantPage" });
            const maFonction = async () => {
              const result = await Swal.fire({
                html: `<div>Cliquer sur le bouton Aperçu ci-dessous pour avoir un aperçu de votre document</div>`,
                icon: "success",
                buttonsStyling: true,
                confirmButtonText: "Aperçu",
                showCancelButton: false,
                cancelButtonText: `Fermer`,
                allowOutsideClick: false,
                allowEscapeKey: false,
                heightAuto: false,
                customClass: {
                  confirmButton: "btn btn-success",
                  cancelButton: "btn btn-warning",
                },
              });

              if (result.isConfirmed) {
                openNewWindow(data.data);
              }
            };
            // Utiliser setTimeout pour exécuter la fonction après la durée spécifiée
            setTimeout(maFonction, 3000);
          }
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    };

    watch(usager, (newValue, oldValue) => {
      const anneActuelle = new Date().getFullYear();
      if (newValue && oldValue !== newValue) {
        const usage = lesUsagers.value.find((el) => el.matricule === newValue);
        moiss.value = [];
        mois.value = [];
        if (usage) {
          const lesMois = [
            ...getMonthsWithinRange2(12 - usage.moisPaye).reverse(),
          ];
          moiss.value = lesMois.map((el) => {
            return {
              value: el + " - " + anneActuelle,
              label: el + " - " + anneActuelle,
            };
          });
        } else {
          //
        }
      }
    });
    watch(mois, (newValue, oldValue) => {
      if (newValue && oldValue !== newValue) {
        montant.value = newValue.length * 2000;
      }
    });
    onMounted(async () => {
      await reupererMode();
    });

    return {
      recuperation,
      show_Modal,
      montant,
      ajouterUsager,
      payer,
      recharger,
      modifUsager,
      selectImp,
      openNewWindow,
      selectedImp,
      selectedItem,
      failHandler,
      reupererUsagers,
      usagerSchema,
      mois,
      usager,
      mode,
      nombre1,
      nombre2,
      impayes,
      somRedevance,
      moiss,
      modes,
      addAPaiement,
      format_date,
    };
  },
});
</script>
<style>
.clickable-row {
  cursor: pointer;
}
.clickable-row:hover {
  background-color: #bf6b6b;
}

.selected-row {
  border: 2px solid green;
  color: #fff;
  background-color: #0f4030; /* Couleur de fond vert clair */
}
</style>
